<template>
  <div class="backdrop-loading">
    <div class="message-container">
      <div class="popup-white">
        <div style="transform: scale(0.5)"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>
        <div>
          {{ loadingMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { authStore } from '../store/auth'
export default {
  name: "loading-load",


  computed: {
    ...mapState(authStore, ['loadingMessage'])
  },
};
</script>

<style>
.backdrop-loading {
  display: fixed;
  background: rgba(0, 0, 0, 0.459);
  width: 100vw;
  height: 100vh;
  z-index: 800;
}
.message-container {
  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-white {
  background: #fff6db;
  min-width: 200px;
  max-width: 80vw;
  height: 90px;
  border-radius: 10px;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 25px 10px 10px;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #F7D557;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

</style>